import React from "react";

import "../style/reset.css"
import "../style/typography.css"

import FeaturedImagePageLayout from "../layouts/featured-image-page-layout";
import SEO from "../components/seo";
import {ThemeProvider} from "styled-components";
import {useThemes} from "../style/themes.hook";
import {CookiesProvider} from "react-cookie";
import {graphql, useStaticQuery} from "gatsby";
import {
  CtaWireframeButton,
  Heading1,
  Heading4,
  ListItem,
  Paragraph,
  UnorderedList
} from "../style/itf-styled-components";
import Img from "gatsby-image/withIEPolyfill";
import {ExternalLink} from "../components/external-link";

const AboutUs = () => {
  const themes = useThemes();
  const images = useStaticQuery(graphql`
        query {
          featuredImage: file(relativePath: { eq: "catalin-speaking-microphone.jpg" }) {
            childImageSharp {
              fluid(maxWidth: 2000, quality:100) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          },
          decorationImage: file(relativePath: { eq: "cleaning-multiple-lenses.jpg" }) {
            childImageSharp {
              fluid(maxWidth: 500, quality:100) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          }
        }`
  );

  return (
    <>
      <CookiesProvider>
        <SEO
          title={`Despre Noi - Imagine Timisoara Festival 2021`}
          description={`Imagine Timisoara Festival, ajuns la cea de-a treia ediție, este un proiect al Asociației Imagine Timisoara.`}
        />
      </CookiesProvider>
      <ThemeProvider theme={themes.light}>
        <FeaturedImagePageLayout
          page="about-us"
          featuredImage={images.featuredImage}
        >
          <Heading1>Despre noi</Heading1>
          <div
            css={`
              display: grid;
              grid-template-columns: 1fr 1fr;
              grid-template-rows: 1fr 1fr;
              grid-column-gap: 15px;
              
              @media (max-width: ${props => props.theme.mobileWidth}) {
                display: flex;
                flex-direction: column;
              }
            `}
          >
            <div>
              <Paragraph>Imagine Timisoara Festival este un proiect al Asociației Imagine Timisoara.</Paragraph>
              <Heading4>Despre Asociație</Heading4>
              <Paragraph>
                Asociația Imagine Timisoara a fost înființată în anul 2019, de către un grup de fotografi și tineri pasionați de evenimente culturale și educaționale. Echipa organizației este compusă din trei membri permanenți, patru colaboratori și mai mulți voluntari punctuali în cadrul proiectelor.
              </Paragraph>
              <Paragraph>Misiunea Asociației Imagine Timisoara este crearea unui festival de fotografie de talie europeană care să înglobeze în activitățile sale următoarele acțiuni:</Paragraph>
              <UnorderedList>
                <ListItem>Promovarea artei fotografice și a artiștilor la început de drum</ListItem>
                <ListItem>Dezvoltarea programelor de educație culturală a fotografilor profesioniști, amatori și a publicului larg, prin organizarea de conferințe și workshopuri tematice dedicate fiecărui tip de fotografie în parte (artistică/fine art, fotografie de stradă, fotografie de eveniment, fotografie de peisaj, fotografie fashion/beauty, fotografie comercială etc.) </ListItem>
                <ListItem>Creșterea mobilității artiștilor și a operelor fotografice</ListItem>
                <ListItem>explorăm căile prin care industria fotografică poate câștiga plusvaloare</ListItem>
                <ListItem>Accesibilizarea artei fotografice în rândul publicului larg.</ListItem>
              </UnorderedList>
            </div>
            <Img
              css={`
                border-radius: 8px;
              `}
              sizes={{
                ...images.decorationImage.childImageSharp.fluid
              }}
              objectPosition="50% top"
            />
            <div>
              <Heading4>Despre Festival</Heading4>
              <Paragraph>Imagine Timisoara Festival este principalul proiect al Asociației Imagine Timișoara. Un eveniment de talie europeană dedicat fotografiei și videografiei, organizat în regiunea de vest a României, festivalul aduce față în față artiștii în formare cu mentorii lor și cu publicul larg. Este un festival multianual, care cuprinde o conferință foto, o serie de workshopuri, concursuri de fotografie, expoziții și târg de echipamente foto-video.</Paragraph>
              <Paragraph>Prima ediție a Imagine Timisoara Festival a avut loc în anul 2019. Fotografia de eveniment, de stradă, de produs, fine art, fashion - toate aceste domenii și-au găsit locul în cadrul ITF.</Paragraph>
              <Paragraph>Anul 2020 a adus cu sine o ediție în format nou, online, adaptat realității debutului de pandemie.</Paragraph>
              <Paragraph>În cadrul celei de-a treia ediții, în 2021, Imagine Timisoara Festival revine în formula consacrată. Anul acesta, ne propunem să aducem totul la o scară fără precedent: 3 conferințe, 21 de workshopuri, 5 concursuri de fotografie, 8 expoziții, 1 târg de echipamente foto-video, 1 sesiune de portofolio review.</Paragraph>
              <Heading4>Imagine Timisoara Festival: Focus to Inspire!</Heading4>
              <Paragraph>
                <CtaWireframeButton
                  as={ExternalLink} to="/downloads/itf-2021-mapa-de-prezentare.pdf"
                >Mapa de prezentare</CtaWireframeButton>
              </Paragraph>

              <Paragraph>
                <CtaWireframeButton
                  as={ExternalLink} to="/downloads/itf-2021-presentation-brochure.pdf"
                >Presentation Brochure</CtaWireframeButton>
              </Paragraph>
            </div>
          </div>
        </FeaturedImagePageLayout>
      </ThemeProvider>
    </>
  );
};

export default AboutUs
